/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import BaseObject from "@shared/BaseObject";
import TimeZoneItem from "@shared/Profile/TimeZoneItem.js";
import {Type} from "@qwoach/class-transformer-wrapper";
import ClientProfile from "@shared/Profile/ClientProfile.js";
import {StatusEnum} from "@/core/components/Status/StatusEnum.js";


export default class ParticipantItem extends BaseObject{

	id: string = null;
	name: string = null;
	email: string = null;
	@Type(() => TimeZoneItem)
	timeZoneItem: TimeZoneItem = null
	inviteStatus: StatusEnum = StatusEnum.ACCEPTED
	sessionConfirmation: StatusEnum = StatusEnum.ACCEPTED;


	constructor(clientId, name, email, timeZoneItem, confirmation, role) {
		super();
		this.id = clientId || null;
		this.name = name || null;
		this.email = email || null;
		this.timeZoneItem = timeZoneItem || null;
		this.sessionConfirmation = confirmation || StatusEnum.ACCEPTED;
		this.role = role || null;
	}

	asParticipant(){
		return this
	}

	asClientProfile(){
		let clientProfile = new ClientProfile()
		clientProfile.setId(this.id)
		clientProfile.name = this.name
		clientProfile.email = this.email
		clientProfile.timeZoneItem = this.timeZoneItem
		return clientProfile
	}

	setSessionCancelled(){
		this.sessionConfirmation = StatusEnum.CANCELLED
	}

	setSessionConfirmed(){
		this.sessionConfirmation = StatusEnum.CONFIRMED
	}

	isConfirmed(){
		return this.sessionConfirmation === StatusEnum.CONFIRMED
	}

	isCancelled(){
		return this.sessionConfirmation === StatusEnum.CANCELLED
	}

	isPending(){
		return this.sessionConfirmation === StatusEnum.PENDING_PAYMENT
	}

	setInviteStatusPending(){
		this.inviteStatus = StatusEnum.PENDING
	}
	setInviteStatusAccepted(){
		this.inviteStatus = StatusEnum.ACCEPTED
	}

	isInvitePending(){
		return this.inviteStatus === StatusEnum.PENDING
	}

	isInviteAccepted(){
		return this.inviteStatus === StatusEnum.ACCEPTED
	}

	getTimeZoneId(){
		return this.timeZoneItem ? this.timeZoneItem.timeZoneId : null
	}



}
